// Strips extraneous properties from a set of fully hydrated character objects
const stripEntities = (entities, stats = false) => {
  if (!entities) return [];
  return entities.map(entity => {
    let result = {
      name: entity.name,
      thumbnailURI: entity.thumbnailURI,
      entityType: entity.entityType,
      id: entity.id,
      thumbnailSmall: entity.thumbnailSmall,
      thumbnailLarge: entity.thumbnailLarge,
    };
    if (stats) {
      result = {
        ...result,
        stats: entity.stats
      };
    }
    return result;
  });
};

/*
  {
    title
    description
    tiers : [{
      name: 'S+',
      character: {
        name: 'Ricochet'
        thumbnailURI:'https://*'
      }
    },
    {
        name: 'F',
        character: {
          name: 'Dynamike'
          thumbnailURI:'https://*'
        }
      }
    ]
  }
*/

const generateTierListPreview = tierlist => {
  const {
    tierJSON,
    title,
    description,
    author,
    permalink,
    game,
    lastPublish,
    featured,
    featuredTier
  } = tierlist;
  const { dimensions } = tierJSON;

  const primaryDimension = dimensions[0];
  let tiers = [];

  const characters = primaryDimension.tiers.reduce(
    (characterAccumulator, tier) => characterAccumulator.concat(tier.characters),
    []
  );

  const tierListCenter = Math.round(characters.length / 2);

  let charactersForPreview = [];

  if (characters.length > 0) {
    charactersForPreview.push(characters[0]);
  }

  if (characters.length > 1) {
    charactersForPreview.push(characters[tierListCenter]);
  }

  if (characters.length > 2) {
    charactersForPreview.push(characters[characters.length - 1]);
  }

  if (charactersForPreview && charactersForPreview.length > 0) {
    charactersForPreview.forEach(characterForPreview => {
      const { thumbnailURI, name } = characterForPreview;
      const containingTier = primaryDimension.tiers.find(jsonTier =>
        jsonTier.characters.find(character => character.name === characterForPreview.name)
      );
      if (containingTier) {
        tiers.push({
          name: containingTier.name,
          numCharacters: containingTier.characters.length,
          character: { thumbnailURI, name }
        });
      }
    });
  }

  const tierListPreview = {
    featured,
    title,
    description,
    author,
    permalink,
    game,
    lastPublish,
    tiers,
    featuredTier
  };

  return tierListPreview;
};

const generateTierListPreviews = tierlists =>
  (tierlists && tierlists.map(tierlist => generateTierListPreview(tierlist))) || [];

module.exports = {
  stripEntities,
  generateTierListPreviews
};
